export default "__VITE_ASSET__E$FzzU21__"